import { Avatar, Box } from '@mui/material';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { usePortalLinkContext } from '~/components/PortalLink';
import { useSelectedEmployeeId } from '~/hooks/employee/useSelectedEmployeeId';
import { People } from '~/services/Http';

import { UserProfileAction } from './components/UserProfileAction';
import { useSxStyles } from './useStyles';
import { useUserProfileOptions } from './useUserProfileOptions';

type Props = {
  employeeProfile: People.EmployeeProfileDto;
  lastLogin: string;
  onChangePicture: () => void;
  onChangePassword: () => void;
  onChangeLanguage: () => void;
};

export const UserProfileOptions = ({
  employeeProfile,
  lastLogin,
  onChangePicture,
  onChangePassword,
  onChangeLanguage,
}: Props) => {
  const { t } = useTranslation();
  const sxStyles = useSxStyles();
  const { translatedUserRoles } = useUserProfileOptions();
  const { selectedEmployeeId } = useSelectedEmployeeId();
  const { isRouteLinksEnabled } = usePortalLinkContext();
  const history = useHistory();
  const loginTime = `${t('laPrevSuccLogin')}: ${
    lastLogin ? moment(lastLogin).format('DD.MM.YYYY hh:mm:ss a') : ''
  }`;

  return (
    <Box sx={sxStyles.dropdownBox}>
      <Box sx={sxStyles.blueBox}>
        <Avatar
          alt={`${employeeProfile.firstName} ${employeeProfile.lastName}`}
          src={employeeProfile.profilePic}
          sx={sxStyles.avatar}
        />
        <Box sx={sxStyles.userNameBox}>
          <Box component={'strong'} sx={sxStyles.nameTitle}>
            {employeeProfile.username} - {translatedUserRoles}
          </Box>
          <Box component={'span'} sx={sxStyles.text}>
            {loginTime}
          </Box>
        </Box>
      </Box>
      <Box sx={sxStyles.whiteBox}>
        <UserProfileAction
          actionTitle={t('laPicture')}
          faIcon="fa-camera"
          onClick={onChangePicture}
        />
        <UserProfileAction
          actionTitle={t('laPassword')}
          faIcon="fa-key"
          onClick={onChangePassword}
        />
        <UserProfileAction
          actionTitle={t('laLanguage')}
          faIcon="fa-globe"
          onClick={onChangeLanguage}
        />
        <UserProfileAction
          actionTitle={t('laUsersetting')}
          faIcon="fa-cogs"
          {...(isRouteLinksEnabled
            ? { onClick: () => history.push('/portal/user/settings') }
            : { href: `/page-userSetting.html?emp=${selectedEmployeeId}` })}
        />
        <UserProfileAction
          actionTitle={t('laHelpcenter')}
          faIcon="fa-question"
          href={`/page-helpCenter.html?emp=${selectedEmployeeId}`}
        />
        <UserProfileAction
          actionTitle={t('laSignOut')}
          faIcon="fa-sign-out"
          href="/page-logout"
        />
      </Box>
    </Box>
  );
};
